import { Component, Injector, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AumicoCoreProvider, IInvitationDialogData, NotificationType } from '@modeso/aumico-lib-core-fe';
import { OrganizationProvider, inviteReferrals } from '@modeso/aumico-lib-users-fe';
import { referralDto } from '@modeso/aumico-lib-users-fe/dtos/referralDto.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { InviteDialogComponent } from '../invite-dialog/invite-dialog.component';

@Component({
    selector: 'aumico-referral-invite',
    templateUrl: './referral-invite.component.html',
    styleUrls: ['./referral-invite.component.scss'],
})
@UntilDestroy()
export class ReferralTeaserComponent implements OnInit {
    @Input() title?: string;
    @Input() text?: string;
    @Input() inviteReferralButtonText?: string;
    @Input() icon?: string;
    @Input() show?: boolean;
    protected invitationDialogRef: MatDialogRef<InviteDialogComponent>;
    private dialogData: IInvitationDialogData;
    constructor(
        injector: Injector,
        private dialog: MatDialog,
        private organizationProvider: OrganizationProvider,
        private readonly coreProvider: AumicoCoreProvider,
        private readonly actionListener$: ActionsSubject,
    ) {
        this.dialogData = this.getInviteUsersDialogData();
    }

    ngOnInit() {
        this.actionListener$.pipe(ofType(inviteReferrals.failure), untilDestroyed(this)).subscribe(() => {
            this.handleError();
        });
        this.actionListener$.pipe(ofType(inviteReferrals.success), untilDestroyed(this)).subscribe(() => {
            this.handleSuccess();
        });
    }

    private getInviteUsersDialogData(): IInvitationDialogData {
        return {
            titleLocalizationKey: 'aumico_reports_referral_invite_dialog_title',
            contentMessage: 'aumico_reports_referral_invite_dialog_content',
            emailInputLabelKey: 'aumico_reports_referral_invite_dialog_input_label',
            emailInputPlaceholderKey: 'aumico_reports_referral_invite_dialog_input_placeholder',
            actionBtnTextKey: 'aumico_reports_referral_invite_dialog_save_button',
            action: (emailChips: string[], message: string) => this.onSaveAndInviteClick(emailChips, message),
            hasMessage: true,
        };
    }
    protected openInvitationDialog(): void {
        this.invitationDialogRef = this.dialog.open(InviteDialogComponent, {
            width: '668px',
            data: this.dialogData,
            panelClass: 'custom-modalbox',
        });
    }

    private onSaveAndInviteClick(emailChips: string[], message: string) {
        this.organizationProvider.dispatchInviteReferrals({ emails: emailChips, message } as referralDto);
        this.dialog.closeAll();
    }

    private handleError(): void {
        this.coreProvider.dispatchAddNotification(
            'aumico_reports_referral_invite_notification_failure_title',
            'aumico_reports_referral_invite_notification_failure_description',
            NotificationType.ERROR,
        );
    }

    private handleSuccess(): void {
        this.coreProvider.dispatchAddNotification(
            'aumico_reports_referral_invite_notification_success_title',
            'aumico_reports_referral_invite_notification_success_description',
            NotificationType.SUCCESS,
        );
    }
}
